const countryRegions = {
    AU: {
        eastCoast: {
            name: 'East Coast',
            states: ['ACT', 'NSW', 'QLD', 'VIC'],
        },
        northernTerritory: {
            name: 'Northern Territory',
            states: ['NT'],
        },
        southAustralia: {
            name: 'South Australia',
            states: ['SA'],
        },
        tasmania: {
            name: 'Tasmania',
            states: ['TAS'],
        },
        westernAustralia: {
            name: 'Western Australia',
            states: ['WA'],
        },
    },
    CA: {
        eastern: {
            name: {
                en: 'Eastern Canada',
                fr: 'Est du Canada',
            },
            states: ['NB', 'NL', 'NS', 'ON', 'PE', 'QC'],
        },
        northern: {
            name: {
                en: 'Northern Canada',
                fr: 'Nord du Canada',
            },
            states: ['YT', 'NT', 'NU'],
        },
        western: {
            name: {
                en: 'Western Canada',
                fr: 'Ouest du Canada',
            },
            states: ['AB', 'BC', 'MB', 'SK'],
        },
    },
    NZ: {
        northIsland: {
            name: 'North Island',
            states: ['NTL', 'AUK', 'WKO', 'BOP', 'GIS', 'TKI', 'MWT', 'HKB', 'WGN'],
        },
        southIsland: {
            name: 'South Island',
            states: ['NSN', 'TAS', 'CAN', 'WTC', 'STL', 'OTA', 'MBH'],
        },
    },
    US: {
        california: {
            name: 'California',
            states: ['CA'],
        },
        central: {
            name: 'Central US',
            states: ['AR', 'IA', 'IL', 'IN', 'KS', 'KY', 'MI', 'MN', 'MO', 'NE', 'OH', 'OK', 'TN', 'WI'],
        },
        eastern: {
            name: 'Eastern US',
            states: [
                'AL',
                'CT',
                'DC',
                'DE',
                'FL',
                'GA',
                'LA',
                'MA',
                'MD',
                'ME',
                'MS',
                'NC',
                'NH',
                'NJ',
                'NY',
                'PA',
                'RI',
                'SC',
                'VT',
                'VA',
                'WV',
            ],
        },
        mountainWest: {
            name: 'Mountain West',
            states: ['CO', 'UT'],
        },
        nonContinental: {
            name: 'Non-Continental US',
            states: ['AK', 'HI'],
        },
        other: {
            name: 'Other',
            states: ['ID', 'MT', 'ND', 'SD', 'WY'],
        },
        texas: {
            name: 'Texas',
            states: ['TX'],
        },
        western: {
            name: 'Western US',
            states: ['AZ', 'NM', 'NV', 'OR', 'WA'],
        },
    },
};
const data = {
    OTHER: {
        name: 'Other',
        parts: {
            AC: 'Ascension Island',
            AD: 'Andorra',
            AF: 'Afghanistan',
            AG: 'Antigua & Barbuda',
            AI: 'Anguilla',
            AL: 'Albania',
            AM: 'Armenia',
            AO: 'Angola',
            AQ: 'Antarctica',
            AR: 'Argentina',
            AS: 'American Samoa',
            AW: 'Aruba',
            AX: 'Åland Islands',
            AZ: 'Azerbaijan',
            BA: 'Bosnia & Herzegovina',
            BB: 'Barbados',
            BD: 'Bangladesh',
            BF: 'Burkina Faso',
            BH: 'Bahrain',
            BI: 'Burundi',
            BJ: 'Benin',
            BL: 'St. Barthélemy',
            BM: 'Bermuda',
            BN: 'Brunei',
            BO: 'Bolivia',
            BQ: 'Caribbean Netherlands',
            BR: 'Brazil',
            BS: 'Bahamas',
            BT: 'Bhutan',
            BW: 'Botswana',
            BY: 'Belarus',
            BZ: 'Belize',
            CC: 'Cocos (Keeling) Islands',
            CD: 'Congo - Kinshasa',
            CF: 'Central African Republic',
            CG: 'Congo - Brazzaville',
            CI: 'Côte d’Ivoire',
            CK: 'Cook Islands',
            CL: 'Chile',
            CM: 'Cameroon',
            CO: 'Colombia',
            CR: 'Costa Rica',
            CU: 'Cuba',
            CV: 'Cape Verde',
            CW: 'Curaçao',
            CX: 'Christmas Island',
            DG: 'Diego Garcia',
            DJ: 'Djibouti',
            DM: 'Dominica',
            DO: 'Dominican Republic',
            DZ: 'Algeria',
            EA: 'Ceuta & Melilla',
            EC: 'Ecuador',
            EG: 'Egypt',
            EH: 'Western Sahara',
            ER: 'Eritrea',
            ET: 'Ethiopia',
            FJ: 'Fiji',
            FK: 'Falkland Islands',
            FM: 'Micronesia',
            FO: 'Faroe Islands',
            GA: 'Gabon',
            GD: 'Grenada',
            GE: 'Georgia',
            GF: 'French Guiana',
            GG: 'Guernsey',
            GH: 'Ghana',
            GI: 'Gibraltar',
            GL: 'Greenland',
            GM: 'Gambia',
            GN: 'Guinea',
            GP: 'Guadeloupe',
            GQ: 'Equatorial Guinea',
            GS: 'South Georgia & South Sandwich Islands',
            GT: 'Guatemala',
            GU: 'Guam',
            GW: 'Guinea-Bissau',
            GY: 'Guyana',
            HN: 'Honduras',
            HT: 'Haiti',
            IC: 'Canary Islands',
            ID: 'Indonesia',
            IM: 'Isle of Man',
            IO: 'British Indian Ocean Territory',
            IQ: 'Iraq',
            IR: 'Iran',
            JE: 'Jersey',
            JM: 'Jamaica',
            KE: 'Kenya',
            KG: 'Kyrgyzstan',
            KH: 'Cambodia',
            KI: 'Kiribati',
            KM: 'Comoros',
            KN: 'St. Kitts & Nevis',
            KP: 'North Korea',
            KW: 'Kuwait',
            KY: 'Cayman Islands',
            LA: 'Laos',
            LB: 'Lebanon',
            LC: 'St. Lucia',
            LK: 'Sri Lanka',
            LR: 'Liberia',
            LS: 'Lesotho',
            LY: 'Libya',
            MA: 'Morocco',
            MD: 'Moldova',
            ME: 'Montenegro',
            MF: 'St. Martin',
            MG: 'Madagascar',
            MH: 'Marshall Islands',
            MK: 'Macedonia',
            ML: 'Mali',
            MM: 'Myanmar (Burma)',
            MN: 'Mongolia',
            MP: 'Northern Mariana Islands',
            MQ: 'Martinique',
            MR: 'Mauritania',
            MS: 'Montserrat',
            MU: 'Mauritius',
            MV: 'Maldives',
            MW: 'Malawi',
            MY: 'Malaysia',
            MZ: 'Mozambique',
            NA: 'Namibia',
            NC: 'New Caledonia',
            NE: 'Niger',
            NF: 'Norfolk Island',
            NG: 'Nigeria',
            NI: 'Nicaragua',
            NP: 'Nepal',
            NR: 'Nauru',
            NU: 'Niue',
            OM: 'Oman',
            PA: 'Panama',
            PE: 'Peru',
            PF: 'French Polynesia',
            PG: 'Papua New Guinea',
            PH: 'Philippines',
            PK: 'Pakistan',
            PM: 'St. Pierre & Miquelon',
            PN: 'Pitcairn Islands',
            PS: 'Palestinian Territories',
            PW: 'Palau',
            PY: 'Paraguay',
            QA: 'Qatar',
            RE: 'Réunion',
            RW: 'Rwanda',
            SA: 'Saudi Arabia',
            SB: 'Solomon Islands',
            SC: 'Seychelles',
            SD: 'Sudan',
            SH: 'St. Helena',
            SJ: 'Svalbard & Jan Mayen',
            SL: 'Sierra Leone',
            SM: 'San Marino',
            SN: 'Senegal',
            SO: 'Somalia',
            SR: 'Suriname',
            SS: 'South Sudan',
            ST: 'São Tomé & Príncipe',
            SV: 'El Salvador',
            SX: 'Sint Maarten',
            SY: 'Syria',
            SZ: 'Swaziland',
            TA: 'Tristan da Cunha',
            TC: 'Turks & Caicos Islands',
            TD: 'Chad',
            TF: 'French Southern Territories',
            TG: 'Togo',
            TH: 'Thailand',
            TJ: 'Tajikistan',
            TK: 'Tokelau',
            TL: 'Timor-Leste',
            TM: 'Turkmenistan',
            TN: 'Tunisia',
            TO: 'Tonga',
            TT: 'Trinidad & Tobago',
            TV: 'Tuvalu',
            TZ: 'Tanzania',
            UG: 'Uganda',
            UM: 'U.S. Outlying Islands',
            UY: 'Uruguay',
            UZ: 'Uzbekistan',
            VA: 'Vatican City',
            VC: 'St. Vincent & Grenadines',
            VE: 'Venezuela',
            VG: 'British Virgin Islands',
            VI: 'U.S. Virgin Islands',
            VN: 'Vietnam',
            VU: 'Vanuatu',
            WF: 'Wallis & Futuna',
            WS: 'Samoa',
            XK: 'Kosovo',
            YE: 'Yemen',
            YT: 'Mayotte',
            ZM: 'Zambia',
            ZW: 'Zimbabwe',
        },
    },
    REAP: {
        name: 'Asia Pacific',
        parts: {
            AU: {
                name: 'Australia',
                parts: {
                    ACT: 'Australian Capital Territory',
                    NSW: 'New South Wales',
                    NT: 'Northern Territory',
                    QLD: 'Queensland',
                    SA: 'South Australia',
                    TAS: 'Tasmania',
                    VIC: 'Victoria',
                    WA: 'Western Australia',
                },
            },
            CN: {
                langs: 'zh',
                name: {
                    en: 'China',
                    zh: '中国大陆',
                },
                parts: {
                    上海: {
                        name: {
                            en: 'Shanghai',
                            zh: '上海',
                        },
                    },
                    云南: {
                        name: {
                            en: 'Yunnan',
                            zh: '云南',
                        },
                    },
                    内蒙古: {
                        name: {
                            en: 'Inner Mongolia',
                            zh: '内蒙古',
                        },
                    },
                    北京: {
                        name: {
                            en: 'Beijing',
                            zh: '北京',
                        },
                    },
                    吉林: {
                        name: {
                            en: 'Jilin',
                            zh: '吉林',
                        },
                    },
                    四川: {
                        name: {
                            en: 'Sichuan',
                            zh: '四川',
                        },
                    },
                    天津: {
                        name: {
                            en: 'Tianjin',
                            zh: '天津',
                        },
                    },
                    宁夏: {
                        name: {
                            en: 'Ningxia',
                            zh: '宁夏',
                        },
                    },
                    安徽: {
                        name: {
                            en: 'Anhui',
                            zh: '安徽',
                        },
                    },
                    山东: {
                        name: {
                            en: 'Shandong',
                            zh: '山东',
                        },
                    },
                    山西: {
                        name: {
                            en: 'Shanxi',
                            zh: '山西',
                        },
                    },
                    广东: {
                        name: {
                            en: 'Guangdong',
                            zh: '广东',
                        },
                    },
                    广西: {
                        name: {
                            en: 'Guangxi',
                            zh: '广西',
                        },
                    },
                    新疆: {
                        name: {
                            en: 'Xinjiang',
                            zh: '新疆',
                        },
                    },
                    江苏: {
                        name: {
                            en: 'Jiangsu',
                            zh: '江苏',
                        },
                    },
                    江西: {
                        name: {
                            en: 'Jiangxi',
                            zh: '江西',
                        },
                    },
                    河北: {
                        name: {
                            en: 'Hebei',
                            zh: '河北',
                        },
                    },
                    河南: {
                        name: {
                            en: 'Henan',
                            zh: '河南',
                        },
                    },
                    浙江: {
                        name: {
                            en: 'Zhejiang',
                            zh: '浙江',
                        },
                    },
                    海南: {
                        name: {
                            en: 'Hainan',
                            zh: '海南',
                        },
                    },
                    湖北: {
                        name: {
                            en: 'Hubei',
                            zh: '湖北',
                        },
                    },
                    湖南: {
                        name: {
                            en: 'Hunan',
                            zh: '湖南',
                        },
                    },
                    甘肃: {
                        name: {
                            en: 'Gansu',
                            zh: '甘肃',
                        },
                    },
                    福建: {
                        name: {
                            en: 'Fujian',
                            zh: '福建',
                        },
                    },
                    西藏: {
                        name: {
                            en: 'Tibet',
                            zh: '西藏',
                        },
                    },
                    贵州: {
                        name: {
                            en: 'Guizhou',
                            zh: '贵州',
                        },
                    },
                    辽宁: {
                        name: {
                            en: 'Liaoning',
                            zh: '辽宁',
                        },
                    },
                    重庆: {
                        name: {
                            en: 'Chongqing',
                            zh: '重庆',
                        },
                    },
                    陕西: {
                        name: {
                            en: 'Shaanxi',
                            zh: '陕西',
                        },
                    },
                    青海: {
                        name: {
                            en: 'Qinghai',
                            zh: '青海',
                        },
                    },
                    黑龙江: {
                        name: {
                            en: 'Heilongjiang',
                            zh: '黑龙江',
                        },
                    },
                },
            },
            HK: {
                langs: ['en', 'zh'],
                name: {
                    en: 'Hong Kong',
                    zh: '香港',
                },
                parts: {
                    'Hong Kong': { name: { en: 'Hong Kong', zh: '香港' } },
                    Kowloon: { name: { en: 'Kowloon', zh: '九龍' } },
                    'New Territories': { name: { en: 'New Territories', zh: '新界' } },
                },
            },
            IN: {
                langs: 'en',
                name: {
                    en: 'India',
                },
                parts: {
                    'Andaman and Nicobar Islands': 'Andaman and Nicobar Islands',
                    'Andhra Pradesh': 'Andhra Pradesh',
                    'Arunachal Pradesh': 'Arunachal Pradesh',
                    Assam: 'Assam',
                    Bihar: 'Bihar',
                    Chandigarh: 'Chandigarh',
                    Chhatisgarh: 'Chhatisgarh',
                    'Dadra and Nagar Haveli and Daman and Diu': 'Dadra and Nagar Haveli and Daman and Diu',
                    Delhi: 'Delhi',
                    Goa: 'Goa',
                    Gujarat: 'Gujarat',
                    Haryana: 'Haryana',
                    'Himachal Pradesh': 'Himachal Pradesh',
                    'Jammu and Kashmir': 'Jammu and Kashmir',
                    Jharkhand: 'Jharkhand',
                    Karnataka: 'Karnataka',
                    Kerala: 'Kerala',
                    Ladakh: 'Ladakh',
                    Lakshadweep: 'Lakshadweep',
                    'Madhya Pradesh': 'Madhya Pradesh',
                    Maharashtra: 'Maharashtra',
                    Manipur: 'Manipur',
                    Meghalaya: 'Meghalaya',
                    Mizoram: 'Mizoram',
                    Nagaland: 'Nagaland',
                    Odisha: 'Odisha',
                    Puducherry: 'Puducherry',
                    Punjab: 'Punjab',
                    Rajasthan: 'Rajasthan',
                    Sikkim: 'Sikkim',
                    'Tamil Nadu': 'Tamil Nadu',
                    Telangana: 'Telangana',
                    Tripura: 'Tripura',
                    'Uttar Pradesh': 'Uttar Pradesh',
                    Uttarakhand: 'Uttarakhand',
                    'West Bengal': 'West Bengal',
                },
            },
            JP: {
                langs: 'ja',
                name: { en: 'Japan', ja: '日本' },
                parts: {
                    三重県: '三重県',
                    京都府: '京都府',
                    佐賀県: '佐賀県',
                    兵庫県: '兵庫県',
                    北海道: '北海道',
                    千葉県: '千葉県',
                    和歌山県: '和歌山県',
                    埼玉県: '埼玉県',
                    大分県: '大分県',
                    大阪府: '大阪府',
                    奈良県: '奈良県',
                    宮城県: '宮城県',
                    宮崎県: '宮崎県',
                    富山県: '富山県',
                    山口県: '山口県',
                    山形県: '山形県',
                    山梨県: '山梨県',
                    岐阜県: '岐阜県',
                    岡山県: '岡山県',
                    岩手県: '岩手県',
                    島根県: '島根県',
                    広島県: '広島県',
                    徳島県: '徳島県',
                    愛媛県: '愛媛県',
                    愛知県: '愛知県',
                    新潟県: '新潟県',
                    東京都: '東京都',
                    栃木県: '栃木県',
                    沖縄県: '沖縄県',
                    滋賀県: '滋賀県',
                    熊本県: '熊本県',
                    石川県: '石川県',
                    神奈川県: '神奈川県',
                    福井県: '福井県',
                    福岡県: '福岡県',
                    福島県: '福島県',
                    秋田県: '秋田県',
                    群馬県: '群馬県',
                    茨城県: '茨城県',
                    長崎県: '長崎県',
                    長野県: '長野県',
                    青森県: '青森県',
                    静岡県: '静岡県',
                    香川県: '香川県',
                    高知県: '高知県',
                    鳥取県: '鳥取県',
                    鹿児島県: '鹿児島県',
                },
            },
            KR: {
                langs: 'ko',
                name: {
                    en: 'South Korea',
                    ko: '대한민국',
                },
            },
            MO: {
                langs: ['en', 'zh'],
                name: {
                    en: 'Macau',
                    zh: '澳門',
                },
            },
            NZ: {
                name: 'New Zealand',
                parts: {
                    NTL: 'Northland',
                    AUK: 'Auckland',
                    WKO: 'Waikato',
                    BOP: 'Bay of Plenty',
                    GIS: 'Gisborne',
                    TKI: 'Taranaki',
                    MWT: 'Manawatu-Wanganui',
                    HKB: "Hawke's Bay",
                    WGN: 'Wellignton',
                    NSN: 'Nelson',
                    TAS: 'Tasman',
                    CAN: 'Canterbury',
                    WTC: 'West Coast',
                    STL: 'Southland',
                    OTA: 'Otago',
                    MBH: 'Marlborough'
                },
            },
            SG: {
                langs: 'en',
                name: {
                    en: 'Singapore',
                },
            },
            TW: {
                langs: 'zh',
                name: {
                    en: 'Taiwan',
                    zh: '台灣',
                },
                parts: {
                    南投: {
                        name: {
                            en: "Nan-t'ou",
                            zh: '南投',
                        },
                    },
                    台中: {
                        name: {
                            en: "T'ai-chung",
                            zh: '台中',
                        },
                    },
                    台北: {
                        name: {
                            en: "T'ai-pei city",
                            zh: '台北',
                        },
                    },
                    台南: {
                        name: {
                            en: "T'ai-nan",
                            zh: '台南',
                        },
                    },
                    台東: {
                        name: {
                            en: "T'ai-tung",
                            zh: '台東',
                        },
                    },
                    嘉義: {
                        name: {
                            en: 'Chia-i',
                            zh: '嘉義',
                        },
                    },
                    基隆: {
                        name: {
                            en: 'Chi-lung',
                            zh: '基隆',
                        },
                    },
                    宜蘭: {
                        name: {
                            en: 'I-lan',
                            zh: '宜蘭',
                        },
                    },
                    屏東: {
                        name: {
                            en: "P'ing-tung",
                            zh: '屏東',
                        },
                    },
                    彰化: {
                        name: {
                            en: 'Chang-hua',
                            zh: '彰化',
                        },
                    },
                    新北: {
                        name: {
                            en: "T'ai-pei county",
                            zh: '新北',
                        },
                    },
                    新竹: {
                        name: {
                            en: 'Hsin-chu',
                            zh: '新竹',
                        },
                    },
                    桃園: {
                        name: {
                            en: "T'ao-yuan",
                            zh: '桃園',
                        },
                    },
                    澎湖: {
                        name: {
                            en: "P'eng-hu",
                            zh: '澎湖',
                        },
                    },
                    花蓮: {
                        name: {
                            en: 'Hua-lien',
                            zh: '花蓮',
                        },
                    },
                    苗栗: {
                        name: {
                            en: 'Miao-li',
                            zh: '苗栗',
                        },
                    },
                    連江: {
                        name: {
                            en: 'Lien-chiang',
                            zh: '連江',
                        },
                    },
                    金門: {
                        name: {
                            en: 'Kin-men',
                            zh: '金門',
                        },
                    },
                    雲林: {
                        name: {
                            en: 'Yun-lin',
                            zh: '雲林',
                        },
                    },
                    高雄: {
                        name: {
                            en: 'Kao-hsiung county',
                            zh: '高雄',
                        },
                    },
                },
            },
        },
    },
    REAU: {
        name: 'Africa',
        parts: {
            ZA: 'South Africa',
        },
    },
    REEU: {
        name: 'Europe',
        parts: {
            AT: {
                langs: 'de',
                name: {
                    de: 'Österreich',
                    en: 'Austria',
                },
            },
            BE: {
                langs: ['nl', 'fr'],
                name: {
                    en: 'Belgium',
                    fr: 'Belgique',
                    nl: 'België',
                },
            },
            BG: {
                name: {
                    bg: 'България',
                    en: 'Bulgaria',
                },
            },
            CH: {
                langs: ['de', 'fr', 'it'],
                name: {
                    de: 'Schweiz',
                    en: 'Switzerland',
                    fr: 'Suisse',
                    it: 'Svizzera',
                },
            },
            CY: {
                name: {
                    el: 'Κύπρος',
                    en: 'Cyprus',
                    tr: 'Kıbrıs',
                },
            },
            CZ: {
                langs: 'cs',
                name: {
                    cs: 'Česko',
                    en: 'Czechia',
                },
            },
            DE: {
                langs: 'de',
                name: {
                    de: 'Deutschland',
                    en: 'Germany',
                },
            },
            DK: {
                langs: 'da',
                name: {
                    da: 'Danmark',
                    en: 'Denmark',
                },
            },
            EE: {
                name: {
                    en: 'Estonia',
                    et: 'Eesti',
                },
            },
            ES: {
                langs: 'es',
                name: {
                    en: 'Spain',
                    es: 'España',
                },
            },
            EU: {
                name: 'Other Europe',
            },
            FI: {
                langs: 'fi',
                name: {
                    en: 'Finland',
                    fi: 'Suomi',
                },
            },
            FR: {
                langs: 'fr',
                name: 'France',
            },
            GB: 'United Kingdom',
            GR: {
                langs: 'el',
                name: {
                    el: 'Ελλάδα',
                    en: 'Greece',
                },
            },
            HR: {
                langs: 'hr',
                name: {
                    en: 'Croatia',
                    hr: 'Hrvatska',
                },
            },
            HU: {
                langs: 'hu',
                name: {
                    en: 'Hungary',
                    hu: 'Magyarország',
                },
            },
            IE: 'Ireland',
            IS: {
                langs: 'is',
                name: {
                    en: 'Iceland',
                    is: 'Ísland',
                },
            },
            IT: {
                langs: 'it',
                name: { en: 'Italy', it: 'Italia' },
                parts: {
                    AG: { name: { en: 'Agrigento', it: 'Agrigento' } },
                    AL: { name: { en: 'Alessandria', it: 'Alessandria' } },
                    AN: { name: { en: 'Ancona', it: 'Ancona' } },
                    AO: { name: { en: 'Aosta', it: 'Aosta' } },
                    AP: { name: { en: 'Ascoli Piceno', it: 'Ascoli Piceno' } },
                    AQ: { name: { en: "L'Aquila", it: "L'Aquila" } },
                    AR: { name: { en: 'Arezzo', it: 'Arezzo' } },
                    AT: { name: { en: 'Asti', it: 'Asti' } },
                    AV: { name: { en: 'Avellino', it: 'Avellino' } },
                    BA: { name: { en: 'Bari', it: 'Bari' } },
                    BG: { name: { en: 'Bergamo', it: 'Bergamo' } },
                    BI: { name: { en: 'Biella', it: 'Biella' } },
                    BL: { name: { en: 'Belluno', it: 'Belluno' } },
                    BN: { name: { en: 'Benevento', it: 'Benevento' } },
                    BO: { name: { en: 'Bologna', it: 'Bologna' } },
                    BR: { name: { en: 'Brindisi', it: 'Brindisi' } },
                    BS: { name: { en: 'Brescia', it: 'Brescia' } },
                    BT: { name: { en: 'Barletta-Andria-Trani', it: 'Barletta-Andria-Trani' } },
                    BZ: { name: { en: 'Bolzano', it: 'Bolzano' } },
                    CA: { name: { en: 'Cagliari', it: 'Cagliari' } },
                    CB: { name: { en: 'Campobasso', it: 'Campobasso' } },
                    CE: { name: { en: 'Caserta', it: 'Caserta' } },
                    CH: { name: { en: 'Chieti', it: 'Chieti' } },
                    CI: { name: { en: 'Carbonia-Iglesias', it: 'Carbonia-Iglesias' } },
                    CL: { name: { en: 'Caltanissetta', it: 'Caltanissetta' } },
                    CN: { name: { en: 'Cuneo', it: 'Cuneo' } },
                    CO: { name: { en: 'Como', it: 'Como' } },
                    CR: { name: { en: 'Cremona', it: 'Cremona' } },
                    CS: { name: { en: 'Cosenza', it: 'Cosenza' } },
                    CT: { name: { en: 'Catania', it: 'Catania' } },
                    CZ: { name: { en: 'Catanzaro', it: 'Catanzaro' } },
                    EN: { name: { en: 'Enna', it: 'Enna' } },
                    FC: { name: { en: 'Forlì-Cesena', it: 'Forlì-Cesena' } },
                    FE: { name: { en: 'Ferrara', it: 'Ferrara' } },
                    FG: { name: { en: 'Foggia', it: 'Foggia' } },
                    FI: { name: { en: 'Firenze', it: 'Firenze' } },
                    FM: { name: { en: 'Fermo', it: 'Fermo' } },
                    FR: { name: { en: 'Frosinone', it: 'Frosinone' } },
                    GE: { name: { en: 'Genova', it: 'Genova' } },
                    GO: { name: { en: 'Gorizia', it: 'Gorizia' } },
                    GR: { name: { en: 'Grosseto', it: 'Grosseto' } },
                    IM: { name: { en: 'Imperia', it: 'Imperia' } },
                    IS: { name: { en: 'Isernia', it: 'Isernia' } },
                    KR: { name: { en: 'Crotone', it: 'Crotone' } },
                    LC: { name: { en: 'Lecco', it: 'Lecco' } },
                    LE: { name: { en: 'Lecce', it: 'Lecce' } },
                    LI: { name: { en: 'Livorno', it: 'Livorno' } },
                    LO: { name: { en: 'Lodi', it: 'Lodi' } },
                    LT: { name: { en: 'Latina', it: 'Latina' } },
                    LU: { name: { en: 'Lucca', it: 'Lucca' } },
                    MB: { name: { en: 'Monza e Brianza', it: 'Monza e Brianza' } },
                    MC: { name: { en: 'Macerata', it: 'Macerata' } },
                    ME: { name: { en: 'Messina', it: 'Messina' } },
                    MI: { name: { en: 'Milano', it: 'Milano' } },
                    MN: { name: { en: 'Mantova', it: 'Mantova' } },
                    MO: { name: { en: 'Modena', it: 'Modena' } },
                    MS: { name: { en: 'Massa-Carrara', it: 'Massa-Carrara' } },
                    MT: { name: { en: 'Matera', it: 'Matera' } },
                    NA: { name: { en: 'Napoli', it: 'Napoli' } },
                    NO: { name: { en: 'Novara', it: 'Novara' } },
                    NU: { name: { en: 'Nuoro', it: 'Nuoro' } },
                    OG: { name: { en: 'Ogliastra', it: 'Ogliastra' } },
                    OR: { name: { en: 'Oristano', it: 'Oristano' } },
                    OT: { name: { en: 'Olbia-Tempio', it: 'Olbia-Tempio' } },
                    PA: { name: { en: 'Palermo', it: 'Palermo' } },
                    PC: { name: { en: 'Piacenza', it: 'Piacenza' } },
                    PD: { name: { en: 'Padova', it: 'Padova' } },
                    PE: { name: { en: 'Pescara', it: 'Pescara' } },
                    PG: { name: { en: 'Perugia', it: 'Perugia' } },
                    PI: { name: { en: 'Pisa', it: 'Pisa' } },
                    PN: { name: { en: 'Pordenone', it: 'Pordenone' } },
                    PO: { name: { en: 'Prato', it: 'Prato' } },
                    PR: { name: { en: 'Parma', it: 'Parma' } },
                    PT: { name: { en: 'Pistoia', it: 'Pistoia' } },
                    PU: { name: { en: 'Pesaro e Urbino', it: 'Pesaro e Urbino' } },
                    PV: { name: { en: 'Pavia', it: 'Pavia' } },
                    PZ: { name: { en: 'Potenza', it: 'Potenza' } },
                    RA: { name: { en: 'Ravenna', it: 'Ravenna' } },
                    RC: { name: { en: 'Reggio Calabria', it: 'Reggio Calabria' } },
                    RE: { name: { en: 'Reggio Emilia', it: 'Reggio Emilia' } },
                    RG: { name: { en: 'Ragusa', it: 'Ragusa' } },
                    RI: { name: { en: 'Rieti', it: 'Rieti' } },
                    RM: { name: { en: 'Roma', it: 'Roma' } },
                    RN: { name: { en: 'Rimini', it: 'Rimini' } },
                    RO: { name: { en: 'Rovigo', it: 'Rovigo' } },
                    SA: { name: { en: 'Salerno', it: 'Salerno' } },
                    SI: { name: { en: 'Siena', it: 'Siena' } },
                    SO: { name: { en: 'Sondrio', it: 'Sondrio' } },
                    SP: { name: { en: 'La Spezia', it: 'La Spezia' } },
                    SR: { name: { en: 'Siracusa', it: 'Siracusa' } },
                    SS: { name: { en: 'Sassari', it: 'Sassari' } },
                    SV: { name: { en: 'Savona', it: 'Savona' } },
                    TA: { name: { en: 'Taranto', it: 'Taranto' } },
                    TE: { name: { en: 'Teramo', it: 'Teramo' } },
                    TN: { name: { en: 'Trento', it: 'Trento' } },
                    TO: { name: { en: 'Torino', it: 'Torino' } },
                    TP: { name: { en: 'Trapani', it: 'Trapani' } },
                    TR: { name: { en: 'Terni', it: 'Terni' } },
                    TS: { name: { en: 'Trieste', it: 'Trieste' } },
                    TV: { name: { en: 'Treviso', it: 'Treviso' } },
                    UD: { name: { en: 'Udine', it: 'Udine' } },
                    VA: { name: { en: 'Varese', it: 'Varese' } },
                    VB: { name: { en: 'Verbano-Cusio-Ossola', it: 'Verbano-Cusio-Ossola' } },
                    VC: { name: { en: 'Vercelli', it: 'Vercelli' } },
                    VE: { name: { en: 'Venezia', it: 'Venezia' } },
                    VI: { name: { en: 'Vicenza', it: 'Vicenza' } },
                    VR: { name: { en: 'Verona', it: 'Verona' } },
                    VS: { name: { en: 'Medio Campidano', it: 'Medio Campidano' } },
                    VT: { name: { en: 'Viterbo', it: 'Viterbo' } },
                    VV: { name: { en: 'Vibo Valentia', it: 'Vibo Valentia' } },
                },
            },
            KZ: { name: { en: 'Kazakhstan', kk: 'Қазақстан' } },
            LI: {
                name: {
                    de: 'Liechtenstein',
                    en: 'Liechtenstein',
                },
            },
            LT: {
                name: {
                    en: 'Lithuania',
                    lt: 'Lietuva',
                },
            },
            LU: {
                langs: ['fr', 'de'],
                name: {
                    de: 'Luxemburg',
                    en: 'Luxembourg',
                    fr: 'Luxembourg',
                },
            },
            LV: {
                name: {
                    en: 'Latvia',
                    lv: 'Latvija',
                },
            },
            MC: 'Monaco',
            MT: 'Malta',
            NL: { langs: 'nl', name: { en: 'Netherlands', nl: 'Nederland' } },
            NO: { langs: 'no', name: { en: 'Norway', no: 'Norge' } },
            PL: {
                langs: 'pl',
                name: {
                    en: 'Poland',
                    pl: 'Polska',
                },
            },
            PT: { langs: 'pt', name: 'Portugal' },
            RO: {
                langs: 'ro',
                name: {
                    en: 'Romania',
                    ro: 'România',
                },
            },
            RS: {
                name: {
                    en: 'Serbia',
                    sr: 'Србија',
                },
            },
            RU: {
                name: {
                    en: 'Russia',
                    ru: 'Россия',
                },
            },
            SE: {
                langs: 'sv',
                name: {
                    en: 'Sweden',
                    sv: 'Sverige',
                },
            },
            SI: {
                langs: 'sl',
                name: {
                    en: 'Slovenia',
                    sl: 'Slovenija',
                },
            },
            SK: {
                name: {
                    en: 'Slovakia',
                    sk: 'Slovensko',
                },
            },
            TR: {
                name: {
                    en: 'Turkey',
                    tr: 'Türkiye',
                },
            },
            UA: {
                name: {
                    en: 'Ukraine',
                    ru: 'Украина',
                    uk: 'Україна',
                },
            },
        },
    },
    REME: {
        name: 'Middle-East',
        parts: {
            AE: {
                langs: ['ar', 'en'],
                name: {
                    ar: 'الإمارات العربية المتحدة',
                    en: 'United Arab Emirates',
                },
            },
            IL: {
                langs: 'he',
                name: {
                    en: 'Israel',
                    he: 'ישראל',
                },
            },
            JO: {
                name: 'Jordan',
                parts: {
                    AJ: 'Ajlun',
                    AM: "'Amman",
                    AQ: "Al 'Aqabah",
                    BA: "Al Balqa'",
                    IR: 'Irbid',
                    JA: 'Jarash',
                    KA: 'Al Karak',
                    MD: 'Madaba',
                    MF: 'Al Mafraq',
                    MN: "Ma'an",
                    TA: 'At Tafilah',
                    ZA: "Az Zarqa'",
                },
            },
        },
    },
    RENA: {
        name: 'North America',
        parts: {
            CA: {
                langs: ['en', 'fr'],
                localeName: {
                    en: 'Canada (En)',
                    fr: 'Canada (Fr)',
                },
                name: 'Canada',
                parts: {
                    AB: 'Alberta',
                    BC: 'British Columbia',
                    MB: 'Manitoba',
                    NB: 'New Brunswick',
                    NL: 'Newfoundland and Labrador',
                    NS: 'Nova Scotia',
                    NT: 'Northwest Territories',
                    NU: 'Nunavut',
                    ON: 'Ontario',
                    PE: 'Prince Edward Island',
                    QC: 'Quebec',
                    SK: 'Saskatchewan',
                    YT: 'Yukon',
                },
            },
            MX: { langs: 'es', name: { en: 'Mexico', es: 'México' } },
            PR: {
                langs: ['es', 'en'],
                localeName: {
                    en: 'Puerto Rico (En)',
                    es: 'Puerto Rico (Es)',
                },
                name: { en: 'Puerto Rico', es: 'Puerto Rico' },
            },
            US: {
                name: 'United States',
                parts: {
                    AK: 'Alaska',
                    AL: 'Alabama',
                    AR: 'Arkansas',
                    AZ: 'Arizona',
                    CA: 'California',
                    CO: 'Colorado',
                    CT: 'Connecticut',
                    DC: 'District Of Columbia',
                    DE: 'Delaware',
                    FL: 'Florida',
                    GA: 'Georgia',
                    HI: 'Hawaii',
                    IA: 'Iowa',
                    ID: 'Idaho',
                    IL: 'Illinois',
                    IN: 'Indiana',
                    KS: 'Kansas',
                    KY: 'Kentucky',
                    LA: 'Louisiana',
                    MA: 'Massachusetts',
                    MD: 'Maryland',
                    ME: 'Maine',
                    MI: 'Michigan',
                    MN: 'Minnesota',
                    MO: 'Missouri',
                    MS: 'Mississippi',
                    MT: 'Montana',
                    NC: 'North Carolina',
                    ND: 'North Dakota',
                    NE: 'Nebraska',
                    NH: 'New Hampshire',
                    NJ: 'New Jersey',
                    NM: 'New Mexico',
                    NV: 'Nevada',
                    NY: 'New York',
                    OH: 'Ohio',
                    OK: 'Oklahoma',
                    OR: 'Oregon',
                    PA: 'Pennsylvania',
                    RI: 'Rhode Island',
                    SC: 'South Carolina',
                    SD: 'South Dakota',
                    TN: 'Tennessee',
                    TX: 'Texas',
                    UT: 'Utah',
                    VA: 'Virginia',
                    VT: 'Vermont',
                    WA: 'Washington',
                    WI: 'Wisconsin',
                    WV: 'West Virginia',
                    WY: 'Wyoming',
                },
            },
        },
    },
};

let cacheEnabled = true;
function getSingleElement(code, part, language) {
    return {
        code: code,
        label: getNameFromPart(part, language),
    };
}
function getNameFromPart(part, language) {
    if (typeof part === 'string') {
        return part;
    }
    const { name } = part;
    if (typeof name === 'string') {
        return name;
    }
    if (language != null && name[language] != null) {
        return name[language];
    }
    return name.en;
}
function getRegionFromParts(parts, language) {
    let tempMap = [];
    let countryCodes = Object.keys(parts);
    for (let countryCode of countryCodes) {
        const country = parts[countryCode];
        tempMap.push(getSingleElement(countryCode, country, language));
    }
    tempMap.sort((a, b) => {
        return a.label.localeCompare(b.label);
    });
    return tempMap;
}
function setCacheEnabled(isEnabled) {
    if (!isEnabled) {
        countryList = null;
        countryListLanguage = undefined;
    }
    cacheEnabled = isEnabled;
}
function getSuperRegions(language) {
    let superRegions = [];
    for (const superRegionCode in data) {
        const superRegion = data[superRegionCode];
        superRegions.push(getSingleElement(superRegionCode, superRegion, language));
    }
    return superRegions;
}
function getSuperRegion(countryCode, language) {
    for (const superRegionCode in data) {
        const superRegion = data[superRegionCode];
        if (superRegion.parts && superRegion.parts[countryCode] != null) {
            return getSingleElement(superRegionCode, superRegion, language);
        }
    }
    return null;
}
function getCountries(superRegionCode, language) {
    if (superRegionCode == null) {
        return getCountryListAll(language);
    }
    return getCountryListBySuperRegion(superRegionCode, language);
}
let countryListLanguage = undefined;
let countryList = null;
function getCountryListAll(language) {
    if (countryList != null && countryListLanguage === language) {
        return countryList;
    }
    let tempMap = [];
    for (const superRegionCode in data) {
        const superRegion = data[superRegionCode];
        for (const countryCode in superRegion.parts) {
            const country = superRegion.parts[countryCode];
            tempMap.push(getSingleElement(countryCode, country, language));
        }
    }
    tempMap.sort((a, b) => {
        return a.label.localeCompare(b.label);
    });
    if (cacheEnabled) {
        countryListLanguage = language;
        countryList = tempMap;
    }
    return tempMap;
}
function getCountryListBySuperRegion(superRegionCode, language) {
    if (data[superRegionCode] == null) {
        return [];
    }
    let { parts } = data[superRegionCode];
    if (parts == null) {
        return [];
    }
    return getRegionFromParts(parts, language);
}
function getLocaleNamesByCountryCode(countryCode) {
    for (const superRegionCode in data) {
        const superRegion = data[superRegionCode];
        let { parts } = superRegion;
        for (const dataCountryCode in parts) {
            if (countryCode === dataCountryCode) {
                let countryData = parts[countryCode];
                if (typeof countryData === 'string') {
                    return {
                        en: countryData,
                    };
                }
                if (countryData.localeName != null) {
                    return countryData.localeName;
                }
                let { name } = countryData;
                if (typeof name === 'string') {
                    return {
                        en: name,
                    };
                }
                return name;
            }
        }
    }
    return null;
}
function getSupportedCountryToLanguageMap() {
    let map = {};
    for (const superRegionCode in data) {
        if (superRegionCode === 'OTHER') {
            continue;
        }
        const superRegion = data[superRegionCode];
        let { parts } = superRegion;
        for (const dataCountryCode in parts) {
            let countryData = parts[dataCountryCode];
            let supportedLanguages;
            if (typeof countryData === 'string' || countryData.langs == null) {
                supportedLanguages = ['en'];
            }
            else if (typeof countryData.langs === 'string') {
                supportedLanguages = [countryData.langs];
            }
            else {
                supportedLanguages = countryData.langs;
            }
            map[dataCountryCode] = supportedLanguages;
        }
    }
    return map;
}
function isSupportedLocale(countryCode, lang) {
    for (const superRegionCode in data) {
        if (superRegionCode === 'OTHER') {
            continue;
        }
        const superRegion = data[superRegionCode];
        let { parts } = superRegion;
        for (const dataCountryCode in parts) {
            if (countryCode === dataCountryCode) {
                let countryData = parts[dataCountryCode];
                if (typeof countryData === 'string') {
                    return lang === 'en';
                }
                let { langs } = countryData;
                if (langs == null) {
                    return lang === 'en';
                }
                else if (typeof langs === 'string') {
                    return lang === langs;
                }
                else {
                    return langs.indexOf(lang) !== -1;
                }
            }
        }
    }
    return false;
}
function getRegionByState(countryCode, state, language) {
    let country = countryRegions[countryCode];
    if (country == null) {
        return null;
    }
    for (let regionCode in country) {
        let region = country[regionCode];
        if (region.states.indexOf(state) !== -1) {
            let { name } = region;
            let localizedName = '';
            if (typeof name === 'string') {
                localizedName = name;
            }
            else if (language == null) {
                localizedName = name['en'];
            }
            else if (name[language] == null) {
                localizedName = name.en;
            }
            else {
                localizedName = name[language];
            }
            return {
                name: localizedName,
                region: regionCode,
                states: region.states,
            };
        }
    }
    return null;
}
function getStates(countryCode, language) {
    const superRegion = getSuperRegion(countryCode);
    if (superRegion == null) {
        return null;
    }
    const superRegionData = data[superRegion.code];
    if (superRegionData.parts == null) {
        return null;
    }
    const countryData = superRegionData.parts[countryCode];
    if (typeof countryData === 'string' || countryData.parts == null) {
        return null;
    }
    const { parts } = countryData;
    return getRegionFromParts(parts, language);
}

export { getCountries, getLocaleNamesByCountryCode, getRegionByState, getStates, getSuperRegion, getSuperRegions, getSupportedCountryToLanguageMap, isSupportedLocale, setCacheEnabled };
